import { FunctionComponent } from 'react';
import DOMPurify from 'dompurify';
import { usePropertyPageQuery } from '../../../graphql/usePropertyPageQuery';
import { styled } from 'styled-components';
import { paletteHelper, spacingHelper, typographyHelper } from '@property.com.au/ui-kit';
import { ProptrackLogoBrickSource } from '../../../../components/ProptrackLogoBrickSource/ProptrackLogoBrickSource';

const DisclaimerContent = styled.div`
  p {
    ${typographyHelper('body01')};
    color: ${paletteHelper('textSecondary')};
  }

  p.state-title {
    ${typographyHelper('body01Bold')};
  }
  h2 {
    display: flex;
    ${typographyHelper('subtitle01')};
    align-items: center;
    gap: ${spacingHelper('extraSmall')};
  }

  ol {
    ${typographyHelper('body01')};
    color: ${paletteHelper('textSecondary')};
    list-style-position: inside;
  }

  a {
    color: ${paletteHelper('textSecondary')};

    &:focus {
      color: ${paletteHelper('textSecondary')};
    }

    &:link {
      color: ${paletteHelper('textSecondary')};
    }
  }
`;

export const PropertyPageDataDisclaimerModalContentWithData: FunctionComponent = () => {
  const vgDisclaimerHtml = usePropertyPageQuery()?.data.propertyPageBySlugV3.vgDisclaimerHtml;

  return <PropertyPageDataDisclaimerModalContent vgDisclaimerHtml={vgDisclaimerHtml ?? null} />;
};

interface PropertyPageDataDisclaimerModalContentProps {
  vgDisclaimerHtml: string | null;
}

export const PropertyPageDataDisclaimerModalContent: FunctionComponent<
  PropertyPageDataDisclaimerModalContentProps
> = ({ vgDisclaimerHtml }) => (
  <DisclaimerContent>
    <p>
      The information displayed here is collected from a range of internal and external sources and
      should be used for reference purposes only. property.com.au makes no representations or
      warranties regarding the accuracy of this data. We recommend that you consult the relevant
      government body, advertising agency or other original source to verify the information before
      relying on it.
    </p>
    <br />
    <h2>Planning Permit</h2>
    <br />
    <p>
      This information is an excerpt from publicly available council planning data and may be
      subject to errors or change. Please consult the issuing council directly for more information.
    </p>
    <br />

    <h2>
      Sold data <ProptrackLogoBrickSource />
    </h2>
    <br />
    <p>
      This information is supplied by realestate.com.au (ABN 21 080 195 535) on behalf of Proptrack
      Pty Ltd (ABN 43 127 386 298)
    </p>
    <br />

    {vgDisclaimerHtml && (
      <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(vgDisclaimerHtml) }} />
    )}
  </DisclaimerContent>
);
